module.exports = __webpack_public_path__ + "static/media/house5.56b9fae6.webp";